// src/pages/technicalAnalysis/utils/relationshipProcessing.js

export const processRelationshipData = (rawData) => {
    // Remove duplicate entities and consolidate their relationships
    const consolidatedEntities = rawData.entity_relationships.reduce((acc, item) => {
      if (!acc[item.primary_entity]) {
        acc[item.primary_entity] = {
          primary_entity: item.primary_entity,
          relationships: [],
          sources: new Set()
        };
      }
      acc[item.primary_entity].relationships.push(...item.relationships);
      acc[item.primary_entity].sources.add(item.source_file);
      return acc;
    }, {});
  
    // Clean up transaction boundaries
    const cleanTransactions = rawData.transaction_boundaries.map(transaction => ({
      ...transaction,
      atomic_operations: transaction.atomic_operations.filter(op => op)
    }));
  
    // Consolidate data ownership
    const consolidatedOwnership = rawData.data_ownership.reduce((acc, item) => {
      if (!acc[item.entity]) {
        acc[item.entity] = {
          entity: item.entity,
          primary_owner: item.primary_owner,
          access_patterns: [],
          sources: new Set()
        };
      }
      if (item.primary_owner) {
        acc[item.entity].primary_owner = item.primary_owner;
      }
      acc[item.entity].access_patterns.push(...item.access_patterns);
      acc[item.entity].sources.add(item.source_file);
      return acc;
    }, {});
  
    return {
      entities: Object.values(consolidatedEntities),
      transactions: cleanTransactions,
      ownership: Object.values(consolidatedOwnership)
        .filter(item => item.primary_owner && item.access_patterns.length > 0)
    };
  };
  